import React from "react";
import logout from "./logout.js";
import getUserRole from "./getRole";
import getLinks from "./getLinks";

const LeftMenu = ({ baseUrl, currentUser, classbookUrl }) => {
  const { first_name, last_name, grade_tag, rtk_client, role } = currentUser;
  const { MAIN_LINKS, SUB_LINKS, BOTTOM_LINKS } = getLinks(
    baseUrl,
    classbookUrl
  );

  const renderTopBlock = () => (
    <div className="menu__top-block-wr">
      <div className="menu__top-block">
        <div className="menu__user-info">
          <span className="menu__user-name">
            {first_name} {last_name}
          </span>
          <span className="menu__user-detals">
            {getUserRole(role)} / {grade_tag}
          </span>
        </div>
        <button className="menu__logout" onClick={logout} />
      </div>
      {rtk_client && <a href={`${baseUrl}payment`}>Пополнить лицевой счёт</a>}
    </div>
  );

  const renderLinks = (array, className) => (
    <div className={className}>
      {array.map((item) => (
        <a
          key={item.url}
          href={item.url}
          target={item.url.startsWith(baseUrl) ? "_self" : "_blank"}
        >
          {item.text}
        </a>
      ))}
    </div>
  );

  return (
    <div className="menu">
      <div className="menu__wrapper">
        {renderTopBlock()}
        <div className="menu__main-container">
          {renderLinks(MAIN_LINKS, "menu__main-links")}
          {renderLinks(SUB_LINKS, "menu__submenu")}
        </div>
        {renderLinks(BOTTOM_LINKS, "menu__bottom")}
      </div>
    </div>
  );
};

export default LeftMenu;



// WEBPACK FOOTER //
// ./app/frontend/components/LeftMenu.js